import "./simple_table.scss"


const Tr = ({ columns =[], rowData })=>{
    return <tr>
        {columns.map(d=><td>{rowData[d.name]}</td>)}
    </tr>
}

export default function SimpleTable({ columns = [], data = [] }) {

    return (
        <div className='simple_table_container'>
            <div className='simple_table'>
                <table>
                    <tbody>
                        {/* Table Head */}
                        <tr>{columns.map(({ label }) => <td className='th'>{label}</td>)}</tr>
                        {/* Table Body */}
                        {data.map((d, i) => <Tr key={i} columns={columns} rowData={d} />)}
                    </tbody>
                </table>
                <br />
            </div>
        </div>
    )
}